module.exports = __webpack_public_path__ + "img/SELLANTE_INDICADO.png";